import { render } from "./FooterPage.vue?vue&type=template&id=ee21320a&scoped=true"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=ee21320a&scoped=true&lang=css"

import exportComponent from "../../dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee21320a"]])

export default __exports__